<!-- Healed brand logo image with localized alt text. -->

<script lang="ts" setup>
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';

import logoUrl from '@sigma/assets/healed-logo-full.svg';

import * as l from './Logo.loc.js';

const t = useTranslate();
</script>

<template>
  <img
    :src="logoUrl"
    :alt="t(l.logo)"
  />
</template>
